<script>
import { ref, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import api from "@/services/api";
import { computed } from "vue";
// ✅ Import your Pinia store
import { useCartStore } from "@/stores/cart";


import { useAuthStore } from "@/stores/authenticate"; // path ko check karo, correct folder ho
 // path ko check karo, correct folder ho

import { toast } from "vue3-toastify"; // ✅ Vue3-toastify import


export default {
    data() {
        return {
            isFixed: false,
            user: null,
            activeButton: null,
            showContactMenu: false,
        }
    },
    created(){
         const userData = localStorage.getItem("user");
         this.user = JSON.parse(userData)
        //  alert(this.user);
            if (userData) {
                this.user = JSON.parse(userData);
                // ✅ ab ye this.user me store hoga
                 console.log("Logged in user:", this.user);
            }
    },
   
    methods: {
        setActive(button) {
      this.activeButton = button;
    },
        onWindowScroll() {
            // Update isFixed based on the scroll position
            this.isFixed = window.pageYOffset > 50;
        },
        toggleSidebar() {
            this.toggleSidebarState();
        },
        closeSidebar() {
            this.closeSidebarState();
        },

         logout() {
          

            
            const authStore = useAuthStore();
             authStore.logout(); 

           // ✅ Optional: show toast
            toast.success("Logged out successfully!");

            // ✅ Redirect to login
            this.$router.push("/login");

              
        }
    },
    mounted() {
        // Attach scroll event listener
        window.addEventListener('scroll', this.onWindowScroll);
       

    },
    beforeUnmount() {
        // Clean up the scroll event listener
        window.removeEventListener('scroll', this.onWindowScroll);
    },
    setup() {
        const isDarkMode = ref(false);
        const route = useRoute();  
        

         // 🔹 Pinia Cart Store
    const cartStore = useCartStore();

    
    const cartCount = computed(() => cartStore.cartCount());


        const toggleDarkMode = () => {
            if (isDarkMode.value) {
                document.documentElement.classList.remove("dark-mode");
                localStorage.setItem("dark-mode", null);
            } else {
                document.documentElement.classList.add("dark-mode");
                localStorage.setItem("dark-mode", "enabled");
            }
            isDarkMode.value = !isDarkMode.value;
        };

        const initializeDarkMode = () => {
            const darkMode = localStorage.getItem("dark-mode");
            isDarkMode.value = darkMode === "enabled";
        };

        onMounted(() => {
            initializeDarkMode();
            cartStore.initGuestToken(); // 👈 ensure token bana ho
            cartStore.fetchCart();      // 👈 initial cart fetch
        });

        const isSidebarOpen = ref(false);

        const toggleSidebarState = () => {
            isSidebarOpen.value = !isSidebarOpen.value;
            document.documentElement.classList.toggle("menu-opened");
        };

        const closeSidebarState = () => {
            isSidebarOpen.value = false;
            document.documentElement.classList.remove("menu-opened");
        };

        watch(route, () => {
            closeSidebarState();
        });

        watch(isDarkMode, (newVal) => {
            if (newVal) {
                document.documentElement.classList.add("dark-mode");
            } else {
                document.documentElement.classList.remove("dark-mode");
            }
        });

        return {
            isDarkMode,
            toggleDarkMode,
            route,
            cartCount,
            isSidebarOpen,
            toggleSidebarState,
            closeSidebarState,
        };
    },
}
</script>

<template>

    <!-- Sticky Header Wrapper -->
    <div class="site-header-wrapper">

    <!-- Header Topbar-->
    <div class="header-topbar text-center" v-if=" route.path ==='/home/index' || route.path.startsWith('/course/') || route.path.startsWith('/pages/') || route.path.startsWith('/courses/') ||
                route.path.startsWith('/category/') || route.path.startsWith('/details/') || route.path.startsWith('/pages-instructor/') || route.path.startsWith('/instructor/') || 
                route.path.startsWith('/instructor-students/') || route.path.startsWith('/students/') || route.path.startsWith('/blog-layouts/') || route.path.startsWith('/blogs/')">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                   <div class="d-flex align-items-center justify-content-center justify-content-lg-start">

   <!-- Address -->
<p class="d-flex align-items-center fw-medium fs-14 mb-2 me-3"
   style="font-family: var(--e-global-typography-text-font-family), Sans-serif !important;">
    
    <img 
      src="@/assets/icons/Icon Location.svg"
      alt="Location Icon"
      style="
        width: 20px;
        height: 20px;
        object-fit: contain;
        margin-right: 6px;
      "
    />

    2 Gymnasium Rd, Macquarie Park NSW 2113
</p>

<!-- Phone -->
<p class="d-flex align-items-center fw-medium fs-14 mb-2"
   style="font-family: var(--e-global-typography-text-font-family), Sans-serif !important;">
    
    <img 
      src="@/assets/icons/Contact.svg"
      alt="Phone Icon"
      style="
        width: 20px;
        height: 20px;
        object-fit: contain;
        margin-right: 6px;
      "
    />

    1300183727
</p>


</div>

                </div>
                <div class="col-lg-6">
    <div class="topbar-buttons mb-1">


    <!-- Accessibility -->
  <a href="javascript:void(0)"
   @click="setActive('accessibility')"
   :class="['btn-top', { active: activeButton === 'accessibility' }]"
   style="font-family: var(--e-global-typography-text-font-family), Sans-serif !important;"
>
    <img 
      src="@/assets/icons/Icon Accessibility.svg"
      alt="Accessibility"
      style="
        width: 20px;
        height: 20px;
        object-fit: contain;
        margin-right: 6px;
      "
    />

    Accessibility
</a>


    <!-- Location -->
  <a 
  href="https://www.nextsense.nextsenseschool.edu.au/location/"
  @click="activeButton = 'location'"
  :class="['btn-top', { active: activeButton === 'location' }]"
  style="font-family: var(--e-global-typography-text-font-family), Sans-serif !important;"
>
  <img 
    src="@/assets/icons/Icon Location.svg"
    alt="Location Icon"
    style="
      width: 20px;
      height: 20px;
      object-fit: contain;
      margin-right: 6px;
    "
  />

  Location
</a>




 <div class="contact-dropdown-wrapper" 
     @mouseenter="showContactMenu = true" 
     @mouseleave="showContactMenu = false"
     style="font-family: var(--e-global-typography-text-font-family), Sans-serif !important;"
>

  <button class="btn-top contact-btn"
          style="font-family: var(--e-global-typography-text-font-family), Sans-serif !important;">

    <img 
      src="@/assets/icons/Contact.svg"
      alt="Contact Icon"
      style="
        width: 20px;
        height: 20px;
        object-fit: contain;
        margin-right: 6px;
      "
    />

    Contact
  </button>

  <!-- DROPDOWN MENU -->
  <div v-if="showContactMenu" 
       class="contact-menu"
       style="font-family: var(--e-global-typography-text-font-family), Sans-serif !important;"
  >
  
    <a 
      href="https://www.nextsense.nextsenseschool.edu.au/contact/" 
      class="contact-item"
      style="font-family: var(--e-global-typography-text-font-family), Sans-serif !important;"
    >
      Get in touch
    </a>

    <a 
      href="https://www.nextsense.nextsenseschool.edu.au/contact/" 
      class="contact-item"
      style="font-family: var(--e-global-typography-text-font-family), Sans-serif !important;"
    >
      Request a callback
    </a>

    <a 
      href="https://www.nextsense.nextsenseschool.edu.au/contact/" 
      class="contact-item"
      style="font-family: var(--e-global-typography-text-font-family), Sans-serif !important;"
    >
      Contact
    </a>

  </div>

</div>




    <!-- 🛒 CART BUTTON -->
<div class="top-cart-btn" style="position: relative;">
  <router-link to="/courses/cart" class="position-relative">
    <i class="isax isax-shopping-cart5"></i>

    <span
      style="
          position: absolute;
    top: -12px;
    right: -8px;
    transform: translate(0px, 40%);
    background: rgb(40, 167, 69);
    padding: 2px 5px;
    border-radius: 50px;
    color: white;
    font-size: 8px;
    font-weight: bold;

      "
    >
      {{ cartCount }}
    </span>

  </router-link>
</div>

<!-- 👤 USER PROFILE DROPDOWN -->
<template v-if="user">
<div class="dropdown profile-dropdown">
 <a href="javascript:void(0);" class="my-account-btn" data-bs-toggle="dropdown">
  <!-- <img src="@/assets/img/user/user-02.jpg" class="avatar-img" /> -->
  <span class="account-text">My Account</span>
</a>


  <div class="dropdown-menu dropdown-menu-end">
        <div class="profile-header d-flex align-items-center">
            <div class="avatar">
                <img src="@/assets/img/user/user-02.jpg" class="img-fluid rounded-circle">
            </div>
            <div>
                <h6>{{ user.fname }}</h6>
                <p>{{ user.email }}</p>
            </div>
        </div>

       <ul class="profile-body">
         <li>
        <router-link
            class="dropdown-item d-inline-flex align-items-center rounded fw-medium"
            to="/students/student-dashboard"
        >
           <i class="isax isax-home-1 me-2"></i>Dashboard
        </router-link>

    </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-profile"><i class="isax isax-security-user me-2"></i>My Profile</router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-quiz"><i class="isax isax-award me-2"></i>Quiz Attempts</router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium2" to="/students/student-order-history"><i class="isax isax-shopping-cart me-2"></i>Order History</router-link>
                                </li>
                                <!-- <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-messages"><i class="isax isax-messages-3 me-2"></i>Messages<span class="message-count">2</span></router-link>
                                </li> -->
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-settings"><i class="isax isax-setting-2 me-2"></i>Settings</router-link>
                                </li>										
                            </ul>

        <div class="profile-footer">
            <button class="btn btn-secondary w-100" @click="logout">
                Logout
            </button>
        </div>
    </div>
</div>
</template>

<!-- 🔓 If not logged in -->
<template v-else>
    <router-link to="/login" class="btn btn-primary"  style="background-color: #00e1dc;border-color: #00e1dc;">SignIn</router-link>
    <router-link to="/register" class="btn btn-secondary " style="background-color: #5bf174;border-color: #5bf174;">Register</router-link>
   <a 
  href="https://www.nextsense.nextsenseschool.edu.au/donate/" 
  rel="noopener noreferrer"
  class="donate-btn"
>
  <span class="donate-icon">
    <i class="fa-regular fa-heart"></i>
  </span>
  Donate
</a>




</template>

   
    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /Header Topbar-->


    <!-- Header -->
    <header class="" :class="{
        'header-one': route.path ==='/home/index',
       
         'fixed': isFixed,
    }">
        <div class="container">
            <div class="header-nav">
                <div class="navbar-header">
                    <a id="mobile_btn" href="javascript:void(0);" @click="toggleSidebar">
                        <span class="bar-icon">
                            <i class="isax isax-menu"></i>
                        </span>
                    </a>
                    <div class="navbar-logo" style="padding-right:288px;">
  <a
    v-if="['/home/index'].includes(route.path) ||
      route.path.startsWith('/course/') || route.path.startsWith('/pages') || route.path.startsWith('/courses') ||
      route.path.startsWith('/category/') || route.path.startsWith('/details/') || route.path.startsWith('/instructor/') || 
      route.path.startsWith('/students/') || route.path.startsWith('/instructor-students/') || 
      route.path.startsWith('/blog-layouts/') || route.path.startsWith('/blogs/')"
    href="https://www.nextsense.nextsenseschool.edu.au/"
    rel="noopener noreferrer"
    class="logo-white header-logo"
  >
    <img src="@/assets/img/logo.svg" class="logo" alt="Logo" style="width:200px; height:auto;" />
  </a>
</div>

                </div>
                
                
                <header-menu></header-menu>
                
                <div v-if="!['/home/index-3', '/home/index-4'].includes(route.path) && !route.path.startsWith('/course/') && !route.path.startsWith('/pages/') && 
                    !route.path.startsWith('/courses/') && !route.path.startsWith('/category/') && !route.path.startsWith('/details/') && 
                    !route.path.startsWith('/instructor/') && !route.path.startsWith('/students/') && !route.path.startsWith('/instructor-students/') &&
                     !route.path.startsWith('/pages-instructor/') && !route.path.startsWith('/pages/') && !route.path.startsWith('/blog-layouts/') && !route.path.startsWith('/blogs/')">
                    <div class="header-btn d-flex align-items-center">	

                       

                        <!-- <div class="icon-btn me-3">
                            <router-link to="/courses/cart" class="position-relative">
                                <i class="isax isax-shopping-cart5"></i>
                                <span class="count-icon bg-success p-1 rounded-pill text-white fs-10 fw-bold"> {{ cartCount }}</span>
                            </router-link>
                        </div> -->
                         <template v-if="!user">
                        <div v-if="route.path !== '/home/index-2' && route.path !== '/home/index-5'">
                           
<!-- 
                               <router-link 
                                to="/login" 
                                class="btn btn-primary d-inline-flex align-items-center me-2"
                                style="background-color: #00e1dc; border-color: #00e1dc;"
                                >
                                Sign In
                                </router-link>

                            <router-link to="/register" class="btn btn-secondary me-2">
                                Register
                            </router-link> -->
                            <!-- <router-link
                                to="/coming-soon"
                                class="btn d-inline-flex align-items-center"
                                style="background:#fff; color:#000; border-radius:30px; padding:6px 16px; font-weight:600; border:1px solid #ddd;"
                            >
                                Donate
                                <i class="fa-regular fa-heart ms-2"></i>
                            </router-link> -->
                        
                        </div>
                        </template>
                         <template v-else>
                         
                <div class="dropdown profile-dropdown">
                        <!-- <a href="javascript:void(0);" class="d-flex align-items-center" data-bs-toggle="dropdown">
                            <span class="avatar">
                                <img src="@/assets/img/user/user-02.jpg" alt="Img" class="img-fluid rounded-circle">
                            </span>
                        </a> -->
                        
                        <!-- <div class="dropdown-menu dropdown-menu-end">
                            <div class="profile-header d-flex align-items-center">
                                <div class="avatar">
                                    <img src="@/assets/img/user/user-02.jpg" alt="Img" class="img-fluid rounded-circle">
                                </div>
                              <div v-if="user">
                                    <h6>{{ user.fname }}</h6>
                                    <p>{{ user.email }}</p>
                                    </div>
                                    <div v-else>
                                    <h6>Guest</h6>
                                    <p>Please log in</p>
                                    </div>

                            </div>
                            <ul class="profile-body">
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-profile"><i class="isax isax-security-user me-2"></i>My Profile</router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-quiz"><i class="isax isax-award me-2"></i>Quiz Attempts</router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium2" to="/students/student-order-history"><i class="isax isax-shopping-cart me-2"></i>Order History</router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-messages"><i class="isax isax-messages-3 me-2"></i>Messages<span class="message-count">2</span></router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-settings"><i class="isax isax-setting-2 me-2"></i>Settings</router-link>
                                </li>										
                            </ul>
                            <div class="profile-footer">
                            <button 
                            class="btn btn-secondary d-inline-flex align-items-center justify-content-center w-100"
                            @click="logout"
                            >
                            <i class="isax isax-logout me-2"></i>
                            Logout
                            </button>
                            </div>
                        </div> -->
                    </div>
            </template>
                        <div v-if="route.path === '/home/index-2' || route.path === '/home/index-5'">
                            <router-link to="/login" class="btn btn-light d-inline-flex align-items-center me-2">
                                <i class="isax isax-lock-circle me-2"></i>Sign In
                            </router-link>
                            <router-link to="/register" class="btn btn-secondary me-0">
                                <i class="isax isax-user-edit me-2"></i>Register
                            </router-link>
                        </div>
                    </div>
                </div> 
                
                
                <div v-if="['/home/index-3', '/home/index-4'].includes(route.path)" class="header-btn d-flex align-items-center">
                    <div class="icon-btn me-2">
                        <a href="javascript:void(0);" id="dark-mode-toggle" @click="toggleDarkMode" :class="{ 'theme-toggle activate': true, 'activate' : isDarkMode }">
                            <i class="isax" :class="[isDarkMode ? 'isax-sun-15' : 'isax-moon']"></i>
                        </a>
                    </div>
                    
                    <div class="dropdown flag-dropdown me-3">
                        <a href="javascript:void(0);" class="dropdown-toggle d-inline-flex align-items-center" data-bs-toggle="dropdown" aria-expanded="false">
                            <img src="@/assets/img/flags/us-flag.svg" class="me-2" alt="flag">ENG
                        </a>
                        <ul class="dropdown-menu p-2 mt-2">
                            <li>
                            <a class="dropdown-item rounded d-flex align-items-center" href="javascript:void(0);">
                                <img src="@/assets/img/flags/us-flag.svg" class="me-2" alt="flag">ENG
                            </a>
                            </li>
                            <li>
                            <a class="dropdown-item rounded d-flex align-items-center" href="javascript:void(0);">
                                <img src="@/assets/img/flags/arab-flag.svg" class="me-2" alt="flag">ARA
                            </a>
                            </li>
                            <li>
                            <a class="dropdown-item rounded d-flex align-items-center" href="javascript:void(0);">
                                <img src="@/assets/img/flags/france-flag.svg" class="me-2" alt="flag">FRE
                            </a>
                            </li>
                        </ul>
                    </div>
                    <div class="dropdown me-3">
                        <a href="javascript:void(0);" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            USD
                        </a>
                        <ul class="dropdown-menu p-2 mt-2" style="">
                            <li><a class="dropdown-item rounded" href="javascript:void(0);">USD</a></li>
                            <li><a class="dropdown-item rounded" href="javascript:void(0);">YEN</a></li>
                            <li><a class="dropdown-item rounded" href="javascript:void(0);">EURO</a></li>
                        </ul>
                    </div>
                    <router-link to="/" class="btn btn-primary d-inline-flex align-items-center me-2">Sign In</router-link>
                    <router-link to="/register" class="btn btn-secondary me-0">Register</router-link>
                </div>
                <div class="header-btn d-flex align-items-center" v-if="route.path.startsWith('/course/') || route.path.startsWith('/pages/') || route.path.startsWith('/courses/') ||
                    route.path.startsWith('/category/') || route.path.startsWith('/details/') || route.path.startsWith('/pages-instructor/') || route.path.startsWith('/blog-layouts/') ||
                    route.path.startsWith('/blogs/')"
                >
                    <!-- <div class="icon-btn me-2">
                        <a href="javascript:void(0);" id="dark-mode-toggle" @click="toggleDarkMode" :class="{ 'theme-toggle activate': true, 'activate' : isDarkMode }">
                            <i class="isax" :class="[isDarkMode ? 'isax-sun-15' : 'isax-moon']"></i>
                        </a>
                    </div> -->
                    <!-- <div class="icon-btn me-3">
                        <router-link to="/courses/cart" class="position-relative">
                            <i class="isax isax-shopping-cart5"></i>
                            <span class="count-icon bg-success p-1 rounded-pill text-white fs-10 fw-bold">{{ cartCount }}</span>
                        </router-link>
                    </div> -->
                    <template v-if="!user">
                     <!-- <router-link to="/login" class="btn btn-light d-inline-flex align-items-center me-2">
                        <i class="isax isax-lock-circle me-2"></i>Sign In
                    </router-link>
                    <router-link to="/register" class="btn btn-secondary me-0">
                        <i class="isax isax-user-edit me-2"></i>Register
                    </router-link> -->
                    </template>


                    <!-- 👇 Agar user login hai -->
  <template v-else>

    <!-- <div class="dropdown profile-dropdown">
                        <a href="javascript:void(0);" class="d-flex align-items-center" data-bs-toggle="dropdown">
                            <span class="avatar">
                                <img src="@/assets/img/user/user-02.jpg" alt="Img" class="img-fluid rounded-circle">
                            </span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                            <div class="profile-header d-flex align-items-center">
                                <div class="avatar">
                                    <img src="@/assets/img/user/user-02.jpg" alt="Img" class="img-fluid rounded-circle">
                                </div>
                              <div v-if="user">
                                    <h6>{{ user.fname }}</h6>
                                    <p>{{ user.email }}</p>
                                    </div>
                                    <div v-else>
                                    <h6>Guest</h6>
                                    <p>Please log in</p>
                                    </div>

                            </div>
                            <ul class="profile-body">
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-profile"><i class="isax isax-security-user me-2"></i>My Profile</router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-quiz"><i class="isax isax-award me-2"></i>Quiz Attempts</router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium2" to="/students/student-order-history"><i class="isax isax-shopping-cart me-2"></i>Order History</router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-messages"><i class="isax isax-messages-3 me-2"></i>Messages<span class="message-count">2</span></router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-settings"><i class="isax isax-setting-2 me-2"></i>Settings</router-link>
                                </li>										
                            </ul>
                            <div class="profile-footer">
                            <button 
                            class="btn btn-secondary d-inline-flex align-items-center justify-content-center w-100"
                            @click="logout"
                            >
                            <i class="isax isax-logout me-2"></i>
                            Logout
                            </button>
                            </div>
                        </div>
                    </div> -->
            </template>
                </div>
                <div class="header-btn d-flex align-items-center" v-if="route.path.startsWith('/instructor/') ||  route.path.startsWith('/instructor-students/')">
                    <div class="icon-btn me-2">
                        <a href="javascript:void(0);" id="dark-mode-toggle" @click="toggleDarkMode" :class="{ 'theme-toggle activate': true, 'activate' : isDarkMode }">
                            <i class="isax" :class="[isDarkMode ? 'isax-sun-15' : 'isax-moon']"></i>
                        </a>
                    </div>
                    <div class="icon-btn me-3">
                        <router-link to="/courses/cart" class="position-relative">
                            <i class="isax isax-shopping-cart5"></i>
                            <span class="count-icon bg-success p-1 rounded-pill text-white fs-10 fw-bold">{{ cartCount }}</span>
                        </router-link>
                    </div>
                    <div class="dropdown profile-dropdown">
                        <a href="javascript:void(0);" class="d-flex align-items-center" data-bs-toggle="dropdown">
                            <span class="avatar">
                                <img src="@/assets/img/user/user-01.jpg" alt="Img" class="img-fluid rounded-circle">
                            </span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                            <div class="profile-header d-flex align-items-center">
                                <div class="avatar">
                                    <img src="@/assets/img/user/user-01.jpg" alt="Img" class="img-fluid rounded-circle">
                                </div>
                                <div>
                                    <h6>Eugene Andre</h6>
                                    <p>instructerdemo@example.com</p>
                                </div>
                            </div>
                            <ul class="profile-body">
                                 <li>
        <router-link
            class="dropdown-item d-inline-flex align-items-center rounded fw-medium"
            to="/students/student-dashboard"
        >
           <i class="isax isax-home-1 me-2"></i>Dashboard
        </router-link>
    </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/instructor/instructor-profile"><i class="isax isax-security-user me-2"></i>My Profile</router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/instructor/instructor-course"><i class="isax isax-teacher me-2"></i>Courses</router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium2" to="/instructor/instructor-earnings"><i class="isax isax-dollar-circle me-2"></i>Earnings</router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/instructor/instructor-payout"><i class="isax isax-coin me-2"></i>Payouts</router-link>
                                </li>
                                <!-- <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/instructor/instructor-message"><i class="isax isax-messages-3 me-2"></i>Messages<span class="message-count">2</span></router-link>
                                </li> -->
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/instructor/instructor-settings"><i class="isax isax-setting-2 me-2"></i>Settings</router-link>
                                </li>										
                            </ul>
                            <div class="profile-footer">
                               
                               
                            </div>
                        </div>
                    </div>
                </div>
                <div class="header-btn d-flex align-items-center" v-if="route.path.startsWith('/students/')"> 
                 
                    <!-- <div class="icon-btn me-3">
                        <router-link to="/courses/cart" class="position-relative">
                            <i class="isax isax-shopping-cart5"></i>
                            <span class="count-icon bg-success p-1 rounded-pill text-white fs-10 fw-bold">{{ cartCount }}</span>
                        </router-link>
                    </div> -->
                    <!-- <div class="dropdown profile-dropdown">
                        <a href="javascript:void(0);" class="d-flex align-items-center" data-bs-toggle="dropdown">
                            <span class="avatar">
                                <img src="@/assets/img/user/user-02.jpg" alt="Img" class="img-fluid rounded-circle">
                            </span>
                        </a>
                        <div class="dropdown-menu dropdown-menu-end">
                            <div class="profile-header d-flex align-items-center">
                                <div class="avatar">
                                    <img src="@/assets/img/user/user-02.jpg" alt="Img" class="img-fluid rounded-circle">
                                </div>
                              <div v-if="user">
                                    <h6>{{ user.fname }}</h6>
                                    <p>{{ user.email }}</p>
                                    </div>
                                    <div v-else>
                                    <h6>Guest</h6>
                                    <p>Please log in</p>
                                    </div>

                            </div>
                            <ul class="profile-body">
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-profile"><i class="isax isax-security-user me-2"></i>My Profile</router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-quiz"><i class="isax isax-award me-2"></i>Quiz Attempts</router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium2" to="/students/student-order-history"><i class="isax isax-shopping-cart me-2"></i>Order History</router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-messages"><i class="isax isax-messages-3 me-2"></i>Messages<span class="message-count">2</span></router-link>
                                </li>
                                <li>
                                    <router-link class="dropdown-item d-inline-flex align-items-center rounded fw-medium" to="/students/student-settings"><i class="isax isax-setting-2 me-2"></i>Settings</router-link>
                                </li>										
                            </ul>
                            <div class="profile-footer">
                            <button 
                            class="btn btn-secondary d-inline-flex align-items-center justify-content-center w-100"
                            @click="logout"
                            >
                            <i class="isax isax-logout me-2"></i>
                            Logout
                            </button>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="sidebar-overlay" :class="{ opened: isSidebarOpen }" @click="closeSidebar"></div>
    </header>
    <!-- /Header -->

    </div>
    <!-- /Sticky Header Wrapper -->
</template>

<style scoped>
/* ── Sticky wrapper: keeps topbar + nav together when scrolling ── */
.site-header-wrapper {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1030;
  background: #fff;
}
/* When header gets .fixed class inside the wrapper, don't re-position it */
.site-header-wrapper :deep(header.fixed) {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  width: 100% !important;
}

/* Default button style */

.btn-top {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border: none !important;       
  border-radius: 25px;
  font-size: 14px;
  font-weight: 600;
  color: black;
  background: transparent !important;
  text-decoration: none;
  transition: 0.3s ease;
}

/* Hover — Full Black */
.btn-top:hover {
  background: black !important;
  color: white !important;
}

/* Active Button */
.btn-top.active {
  background: black !important;
  color: white !important;
}



/* Donate ka default pink */
.btn-top.donate {
  background: #ff84b6;
}

/* Active button style */
.btn-top.active {
  background: black !important;
  color: white !important;
}

/* TOP HEADER cart + profile buttons FIX */

/* Cart Outer Button */
.top-cart-btn {
  display: inline-flex;
  align-items: center !important; 
  justify-content: center;
  border: 2px solid black;
  border-radius: 25px;
  padding: 6px 19px;
  background: white;
  position: relative;
}

/* Cart Icon */
.top-cart-btn i {
  font-size: 18px;
  color: black;
}

/* Cart Count Badge */
.top-cart-btn .count-icon {
  position: absolute;
  top: -5px;
  right: -5px;
}

/* Profile avatar circle button */
.top-profile-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid black;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background: white;
  overflow: hidden;
}

/* Avatar image */
.top-profile-btn img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

/* Dropdown alignment fix */
.profile-dropdown .dropdown-menu {
  background: white !important;
  border-radius: 10px;
  border: 1px solid #ddd;
}

.topbar-buttons {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: nowrap; /* IMPORTANT -- sab items same line me rahenge */
    justify-content: flex-end;
}

/* LEFT + RIGHT topbar perfect vertical alignment */
.header-topbar .row {
    display: flex;
    align-items: center;
}

/* Left Text elements ka bottom margin fix */
.header-topbar p {
    margin-bottom: 0 !important;
    line-height: 1 !important;
}

/* Topbar ka total height equal rakhne ke liye */
.header-topbar {
    padding: 5px 0;
}


/* MY ACCOUNT hover = like Accessibility & Contact buttons */
.my-account-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 2px solid #000;
  padding: 5px 14px;
  border-radius: 25px;
  background: transparent !important;
  cursor: pointer;
  text-decoration: none;
  color: #000;
  transition: 0.3s ease;
}

/* 👇 Hover — SAME as other buttons */
.my-account-btn:hover {
  background: black !important;
  color: white !important;
}

/* Text inside also white on hover */
.my-account-btn:hover .account-text {
  color: white !important;
}

.my-account-btn .avatar-img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #000;
}

.account-text {
  font-size: 14px;
  font-weight: 600;
  color: #000;
}

/* Donate button wrapper */
.donate-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ff84b6;
  padding: 6px 18px 6px 10px;
  border-radius: 30px;
  font-weight: 600;
  text-decoration: none;
  color: #000;
  border: none;
}

/* LEFT Heart Icon inside white circle */
.donate-icon {
  width: 28px;
  height: 28px;
  background: #fff;
  border: 2px solid black;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
}

/* Heart icon style */
.donate-icon i {
  font-size: 15px;
  color: black;
}

/* Hover — pink button remains same (no change) */
.donate-btn:hover {
  background: #ff84b6 !important;
  color: #000 !important;
}

.donate-btn:hover .donate-icon {
  background: white !important;
  border-color: black !important;
}

.donate-btn:hover i {
  color: black !important;
}

/* CONTACT DROPDOWN WRAPPER */
.contact-dropdown-wrapper {
  position: relative;
  display: inline-block;
  z-index: 9999 !important;
  text-align: left !important;
}

/* CONTACT MENU BOX */
.contact-menu {
  position: absolute;
  top: 42px;
  left: 0;
  background: #5bf174;   /* Green */
  padding: 15px 20px;
  border-radius: 4px;
  width: 180px;
  box-shadow: 0 3px 8px rgba(0,0,0,0.15);
  z-index: 99999 !important;
}

/* EACH ITEM */
.contact-item {
  display: block;
  padding: 8px 0;
  font-weight: 600;
  color: black;
  text-decoration: none;
  border-bottom: 2px solid black;
}

/* REMOVE LAST BORDER */
.contact-item:last-child {
  border-bottom: none;
}

/* HOVER */
.contact-item:hover {
  opacity: 0.7;
}






</style>